import { Grid, IconSuccess32, ResponsiveSection, Text } from '@stitch-fix/mode-react';
import type { BrandsValuePageData } from '../../types';
import styles from './index.module.scss';
interface ControlSectionProps {
  data: BrandsValuePageData['control'];
}
export const ControlSection = ({
  data
}: ControlSectionProps) => {
  return <section className={styles.section}>
      <ResponsiveSection width="xlarge" gutter="standard">
        <div className={styles.container}>
          <Text as="p" className={styles.eyebrow} setting="eyebrow-medium">
            {data.eyebrow}
          </Text>
          <Text as="h2" className={styles.title} setting="display-large">
            {data.title}
          </Text>
          {data.description ? <Text as="p" className={styles.description} setting="body-medium">
              {data.description}
            </Text> : null}

          <div className={styles.gridWrap}>
            <Grid columns={{
            sm: 1,
            lg: 3
          }} spacing="standard">
              {data.cards.map(card => <div className={styles.card} key={card.id}>
                  <IconSuccess32 className={styles.successIcon} color="inherit" purpose="decorative" />
                  <Text as="h3" className={styles.cardTitle} setting="title-small">
                    {card.title}
                  </Text>
                  <Text as="p" className={styles.cardDescription} setting="body-medium">
                    {card.description}
                  </Text>
                </div>)}
            </Grid>
          </div>
        </div>
      </ResponsiveSection>
    </section>;
};